import React from "react";
import T from "prop-types";

import { Field, Inputs, Row } from "2g-form";

import { useServerMessage } from "b2b/i18n";
import useMessages from "./i18n/useMessages";

export function ProduktySwitch({ zdroj, ...props } = {}) {
  const message = useServerMessage();
  const { produktyLabel } = useMessages();
  return !zdroj ? null : (
    <Row asGroup>
      <Field
        key={zdroj.zdroj.id}
        items={zdroj.produkty}
        label={produktyLabel()}
        component={Inputs.RadioGroup}
        asSwitch
        path="produkt"
        content={({ data }) => message(data.produkt, "nazev")}
        {...props}
      />
    </Row>
  );
}

ProduktySwitch.propTypes = { typZdroje: T.object, zdroj: T.object };

export default React.memo(ProduktySwitch);
